import { motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'
import { Button } from '~/components/ui/button'
import { mapEmitter } from '~/domains/search/emitters/search.emitters'
import { useSearchSpaces } from '~/domains/search/hooks/use-search-spaces.hook'

export const ResetSearchButton = () => {
	const { t } = useTranslation()
	const { setActiveAlternative } = useSearchSpaces()

	return (
		<motion.div
			initial={{ y: -40, opacity: 0 }}
			exit={{ y: -40, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{
				y: { type: 'spring', duration: 0.5 },
				opacity: { duration: 0.2 },
			}}
			className='-translate-x-1/2 absolute top-4 z-[9999] flex w-full justify-center'
		>
			<Button
				onClick={() => {
					setActiveAlternative(undefined)

					mapEmitter.emit('map.fitBounds')
				}}
			>
				{t('search:actions.resetMap')}
			</Button>
		</motion.div>
	)
}
